
import { defineComponent } from "vue";

import { useStore } from "vuex";
import { Storage } from "@/core/helpers/Storage";
import AdminDashboard from "@/pages/dashboard/AdminDashboard.vue";
export default defineComponent({
  name: "dashboard",
  components: {
    AdminDashboard,
    
  },
  setup() {
    return {
      Storage,
    };
  },
});
